import { Box, type BoxProps, HStack, IconButton } from "@chakra-ui/react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { t } from "@lingui/macro";
import { DragHandle } from "@src/components/ui-kit";
import type { CSSProperties, FC, ReactElement } from "react";

type SortableSettingItemProps = {
  id: string;
  children: ReactElement;
} & Omit<BoxProps, "id" | "children">;

export const SortableSettingItem: FC<SortableSettingItemProps> = ({
  id,
  children,
  ...props
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
  });

  const containerStyle: CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 2 : "initial",
  };

  return (
    <Box ref={setNodeRef} {...props} sx={containerStyle} {...attributes}>
      <HStack>
        <IconButton
          colorScheme="grey"
          size="sm"
          variant="ghost"
          {...listeners}
          aria-label={t`Drag to reorder`}
          icon={<DragHandle />}
        />
        {children}
      </HStack>
    </Box>
  );
};
